{
  "name": "@homer.core/demand",
  "version": "1.11.5",
  "type": "module",
  "private": false,
  "config": {},
  "main": "./dist/index.js",
  "module": "./src/index.js",
  "exports": {
    ".": "./src/index.js",
    "./package.json": "./package.json",
    "./stub": "./src/stub.js"
  },
  "scripts": {},
  "dependencies": {
    "@homer.core/emitter": "*",
    "@homer.core/scheduler": "*",
    "@homer.core/storage.local": "*",
    "@homer.task/fetch": "*"
  },
  "devDependencies": {},
  "requires": [],
  "loads": []
}
